/**
 * Enum for average type, which is used in calculating the MA envelope
 * @readonly
 * @enum {string}
 */
export const averageTypes = Object.freeze({
	/** Use EMA in MAE calculations */
	EMA: 'ema',
	/** Use SMA in MAE calculations */
	SMA: 'sma',
	/** Use WMA in MAE calculations */
	WMA: 'wma'
});

export default {
	averageTypes
};
